import { ReturnTranslatedText } from '@wajeez-web/core/localization';

import { ContentEntityTypeFormBuilder } from './ContentEntityTypeFormBuilder';

interface ContentEntityTypeCreateFormProps {
  onSubmit: (collectionComponentTypeId: number) => void;
  onCancel: () => void;
}

export const ContentEntityTypeCreateForm = ({
  onSubmit,
  onCancel,
}: ContentEntityTypeCreateFormProps) => {
  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Create New Type'}`}
          origintext="Create New Type"
        />
      </h1>
      <div className="mt-6">
        <ContentEntityTypeFormBuilder
          type="Create"
          onSubmit={onSubmit}
          onCancel={onCancel}
        />
      </div>
    </div>
  );
};
